import React, { useEffect, useRef, useState } from 'react';
import AdSense from 'react-adsense';

// Global tracking of initialized ad slots
const initializedAdSlots = new Set();

const AdUnit = ({ adSlot, adFormat = 'auto', className = '' }) => {
  const adRef = useRef(null);
  const [canRenderAd, setCanRenderAd] = useState(true);

  useEffect(() => {
    // Check if this ad slot has already been initialized
    if (initializedAdSlots.has(adSlot)) {
      setCanRenderAd(false);
      return;
    }

    const adElement = adRef.current;
    
    if (adElement) {
      try {
        // Ensure adsbygoogle is initialized
        window.adsbygoogle = window.adsbygoogle || [];
        
        // Only push if the ad hasn't been initialized before
        if (!initializedAdSlots.has(adSlot)) {
          window.adsbygoogle.push({});
          initializedAdSlots.add(adSlot);
        }
      } catch (e) {
        console.error('AdSense initialization error:', e);
        setCanRenderAd(false);
      }
    }

    // Cleanup function to remove the slot from initialized slots if component unmounts
    return () => {
      initializedAdSlots.delete(adSlot);
    };
  }, [adSlot]);

  // If the ad slot is already initialized, don't render
  if (!canRenderAd) {
    return null;
  }

  return (
    <div 
      ref={adRef} 
      className={`ad-container ${className}`}
    >
      <AdSense.Google
        key={adSlot}
        client="ca-pub-8417667942687708"
        slot={adSlot}
        style={{ display: 'block' }}
        format={adFormat}
        responsive="true"
      />
    </div>
  );
};

export default AdUnit;
